export default "__VITE_ASSET__CAm8HiD2__"